import React, { useState, useEffect } from 'react';
import { Duration } from 'luxon';

import {
  getCurrentDateAndTime,
  convertSQLDateToLocalDate,
} from '../Utils/helper';

let clockInterval;

const Timer = ({ attendance }) => {
  const [clockTime, setClockTime] = useState('00:00:00');

  const updateClock = (time) => {
    clockInterval = setInterval(() => {
      if (time) {
        time = time.plus({ seconds: 1 });
        const formattedTime = time.toFormat('HH:mm:ss');

        setClockTime(formattedTime);
      }
    }, 1000);
  };
  // Function to convert time to Luxon Duration
  const convertTimeToLuxonDuration = (timeString) => {
    const [hours, minutes, seconds] = timeString.split(':');
    return Duration.fromObject({
      hours: parseInt(hours, 10),
      minutes: parseInt(minutes, 10),
      seconds: parseInt(seconds, 10),
    });
  };

  // START WORK TIMER
  const workTimer = (currentTime) => {
    const checkInTime = convertSQLDateToLocalDate(attendance?.checkIn);

    // Convert totalBreakHours and totalDriveHours to Luxon Duration objects
    const totalBreakDuration = convertTimeToLuxonDuration(
      attendance?.totalBreakHours,
    );
    const totalDriveDuration = convertTimeToLuxonDuration(
      attendance?.totalDriveHours,
    );

    // Calculate the total time difference
    let diff = currentTime?.diff(checkInTime, ['hours', 'minutes', 'seconds']);

    // Subtract totalBreakDuration and totalDriveDuration from the time difference
    diff = diff?.minus(totalDriveDuration).minus(totalBreakDuration);

    // Extract hours, minutes, and seconds from the remaining duration
    const { hours = 0, minutes = 0, seconds = 0 } = diff.toObject() || '';

    currentTime = currentTime.set({ hours, minutes, seconds });
    return currentTime;
  };

  // START BREAK TIMER
  const breakTimer = (currentTime) => {
    const totalBreakHours = attendance?.totalBreakHours || '00:00:00';

    const totalBreakDuration = convertTimeToLuxonDuration(totalBreakHours);

    const breakStartTime = convertSQLDateToLocalDate(
      attendance?.attendance_details?.[0]?.breakStart,
    );

    // Calculate the total time difference
    let diff = currentTime?.diff(breakStartTime, [
      'hours',
      'minutes',
      'seconds',
    ]);

    // Subtract totalBreakDuration and totalDriveDuration from the time difference
    diff = diff?.plus(totalBreakDuration);

    // Extract hours, minutes, and seconds from the remaining duration
    const { hours = 0, minutes = 0, seconds = 0 } = diff.toObject() || '';

    currentTime = currentTime.set({ hours, minutes, seconds });
    return currentTime;
  };
  // START DRIVE TIMER
  const driveTimer = (currentTime) => {
    const totalDriveHours = attendance?.totalDriveHours || '00:00:00';

    const totalDriveDuration = convertTimeToLuxonDuration(totalDriveHours);

    const driveInTime = convertSQLDateToLocalDate(
      attendance?.attendance_details?.[0]?.driveIn,
    );

    // Calculate the total time difference
    let diff = currentTime?.diff(driveInTime, ['hours', 'minutes', 'seconds']);

    diff = diff?.plus(totalDriveDuration);

    // Extract hours, minutes, and seconds from the remaining duration
    const { hours = 0, minutes = 0, seconds = 0 } = diff.toObject() || '';

    currentTime = currentTime.set({ hours, minutes, seconds });
    return currentTime;
  };

  // when user clocks in , starts break or drive in then start timer accordingly
  useEffect(() => {
    if (attendance?.checkIn) {
      let currentTime = getCurrentDateAndTime();
      if (attendance?.status === 'checkIn') {
        currentTime = workTimer(currentTime);
      } else if (
        attendance?.status === 'breakStart' &&
        attendance?.attendance_details?.[0]?.status === 'breakStart'
      ) {
        currentTime = breakTimer(currentTime);
      } else if (
        attendance?.status === 'driveIn' &&
        attendance?.attendance_details?.[0]?.status === 'driveIn'
      ) {
        currentTime = driveTimer(currentTime);
      }

      updateClock(currentTime);
    }
  }, [attendance?.checkIn]);

  // clear clock interval when component will unmount
  useEffect(() => {
    return () => {
      clearInterval(clockInterval);
    };
  }, []);

  return <span> {clockTime}</span>;
};

export default Timer;
